/*
 * @Description:my train api
 * @Date: 2022-11-04 14:58:41
 * @FilePath: \school-website-h5\src\pages\api\myTrain.js
 * @LastEditTime: 2022-11-17 15:09:20
 */
import { getFetch, postFetch } from '@/plugins/http'

const baseHost = `${process.env.VUE_APP_HOST}`
const commonApiBaseUrl = `${baseHost}/hike-boot/common/api`
const zhsTeachingHost = '//fteaching.zhihuishu.com'
const zhsLibraryHost = '//hike-shared-library.zhihuishu.com'
export default {
  getMyTrainProgram(data) {
    return getFetch(`${commonApiBaseUrl}/34-queryMyTrainingTermPageList/myTrainingProgram`, data)
  },
  getMyTrainDetails(data) {
    return getFetch(`${commonApiBaseUrl}/32-getMyTrainingInfo/myTrainingProgram`, data)
  },
  getMyTrainTermDetails(data) {
    return getFetch(`${commonApiBaseUrl}/34-getMyOperationCoursePageList/myTrainingProgram`, data)
  },
  getMyTrainOrder(data) {
    return getFetch(`${commonApiBaseUrl}/32-getMyOrderInfo/myTrainingProgram`, data)
  },
  getPayAddresses(data) {
    return getFetch(`${baseHost}/hike-boot/trainingTermApply/ax/getPaymentAddress`, data)
  },
  getRejectInfo(data) {
    return getFetch(`${baseHost}/hike-boot/trainingTermApply/getRejectedApplyInfo`, data)
  },
  getApplyInfo(data) {
    return getFetch(`${baseHost}/hike-boot/trainingTermApply/getApplyInfo`, data)
  },
  getHomeTrainInfo(data) {
    return getFetch(`${commonApiBaseUrl}/33-rcm_px_training_list/portal_homepage`, data)
  },
  getCertificateStatus(data) {
    return getFetch(
      `${baseHost}/hike-boot/common/api/30-getTrainingCertificateStatus/trainingTerm`,
      data
    )
  },
  // 查看报名状态
  getApplyStatusList(data) {
    return getFetch(`${baseHost}/hike-boot/trainingTermApply/getApplyStatusList`, data)
  }
}
